// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z62h","toggle":"styles_toggle__1lqRL","preview":"styles_preview__1ZZd2"};